export const environment = {
  production: false,
  // apiUrl: "https://apibestdrop.ajatus.in/",
  // imageUrl: "https://apibestdrop.ajatus.in/"
  // UiUrl: "http://localhost:4200/downloadInvoice",
  //apiUrl: 'http://dap.centralindia.cloudapp.azure.com/api/',
  apiUrl: "https://core.diaq.hhgs.in/api/",
  dap_imageUrl: "https://node.diaq.hhgs.in/",
  dap_weatherUrl: "https://api.weatherapi.com/v1/",
  // imageUrl: "http://localhost:3000/",
  //dap_url: "http://localhost:5000/",
  // dap_url: "http://localhost:3001/",
  // dap_url: "https://node.diaq.in/",
  dap_url: "https://api.staging.diaq.hhgs.in/",
};

//https://core-ce.diaq.in/
